export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20with%20open%20laptop%20displaying%20organized%20spreadsheet%20data%20alongside%20curated%20fashion%20accessories%20leather%20goods%20and%20packaging%20on%20warm%20wooden%20desk%2C%20soft%20natural%20light%20streaming%20from%20left%20window%2C%20professional%20product%20sourcing%20atmosphere%2C%20editorial%20business%20photography%2C%20clean%20sophisticated%20aesthetic%2C%20high%20detail%2C%20warm%20honey%20and%20cream%20tones&width=1600&height=900&seq=cta-mulebuy-v2-2026&orientation=landscape"
          alt="Access Mulebuy Spreadsheet - start sourcing smarter today"
          title="Get the Mulebuy Spreadsheet now"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-5xl font-bold text-background-50 tracking-wide uppercase mb-3 md:mb-4">
          Get Access to Updated Mulebuy Spreadsheet
        </h2>
        <p className="text-background-50/85 text-sm md:text-lg max-w-md mx-auto mb-6 md:mb-8">
          Stay ahead with the latest curated product lists, verified agents, and trending items.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line text-lg"></i>
            Access Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-foreground-900 hover:bg-background-100 text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            View Product Categories
            <i className="ri-grid-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}